




































































































































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import GenericPMSTableMenu from "@/components/generic-pms-table/GenericPMSTableMenu.vue";
import { SortableTableHeader } from "@/components/generic-pms-table/SortableTableDirective";
import SortableTable from "@/components/generic-pms-table/SortableTableDirective";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import { saveFile } from "@/shared/saveFile";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import VCustomer from "@/shared/models/vCustomer";
import CustomerForm from "@/components/CustomerForm.vue";
import * as _ from "lodash";
import { Notification } from "../store/modules/notifications";
import NoData from "@/components/misc/NoData.vue";
import { IdentificationDocumentType } from "@/shared/models/identificationDocumentType";
import { CustomerTypeEnum } from "@/shared/models/enums.type";

@Component({
  components: {
    GenericPMSTableMenu,
    SortableHeadersTable,
    CustomerForm,
    NoData,
  },
  directives: {
    SortableTable,
  },
})
export default class CustomersTable extends Vue {
  settingsOpen = false;

  @Prop() custmerType?: "all" | "reservationHolder" | "guest" | "owner";

  mounted() {
    if (
      !this.identificationDocumentTypes ||
      this.identificationDocumentTypes.length == 0
    ) {
      this.refreshIdentificationDocumentTypes?.();
    }

    if (this.custmerType === "all") {
      this.filters.customerTypeId = null;
    }
    if (this.custmerType === "reservationHolder") {
      this.filters.customerTypeId = CustomerTypeEnum.ReservationHolder;
    }
    if (this.custmerType === "guest") {
      this.filters.customerTypeId = CustomerTypeEnum.Guest;
    }
    if (this.custmerType === "owner") {
      this.filters.customerTypeId = CustomerTypeEnum.Owner;
    }
  }

  headers: SortableTableHeader[] = [
    {
      text: "VCustomer.name",
      value: "name",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: ["name"],
    },
    {
      text: "VCustomer.countryOfResidenceName",
      value: "countryOfResidenceName",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: ["countryOfResidenceName"],
    },
    {
      text: "VCustomer.eMail",
      value: "eMail",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: ["eMail"],
    },
    {
      text: "VCustomer.telephoneNumber",
      value: "telephoneNumber",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: ["telephoneNumber"],
    },
    {
      text: "VCustomer.identificationNumber",
      value: "identificationNumber",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: ["identificationNumber"],
    },
    {
      text: "VCustomer.isLegalEntity",
      value: "isLegalEntity",
      active: false,
      default: false,
      class: "resize-header",
      exportHeaders: ["isLegalEntity"],
      align: "center",
    },
    {
      text: "VCustomer.identificationDocumentType",
      value: "identificationDocumentTypeId",
      active: false,
      default: false,
      class: "resize-header",
      exportHeaders: ["identificationDocumentTypeId"],
    },
    {
      text: "VCustomer.numberOfReservations",
      value: "numberOfReservations",
      active: false,
      default: false,
      class: "resize-header",
      exportHeaders: ["numberOfReservations"],
    },
    {
      text: "VCustomer.numberOfStays",
      value: "numberOfStays",
      active: false,
      default: false,
      class: "resize-header",
      exportHeaders: ["numberOfStays"],
    },
    {
      text: "VCustomer.numberOfNights",
      value: "numberOfNights",
      active: false,
      default: false,
      class: "resize-header",
      exportHeaders: ["numberOfNights"],
    },
    {
      text: "VCustomer.numberOfCancelations",
      value: "numberOfCancelations",
      active: false,
      default: false,
      class: "resize-header",
      exportHeaders: ["numberOfCancelations"],
    },
    {
      text: "VCustomer.numberOfNoShows",
      value: "numberOfNoShows",
      active: false,
      default: false,
      class: "resize-header",
      exportHeaders: ["numberOfNoShows"],
    },
    {
      text: "Actions",
      value: "actions",
      sortable: false,
      active: true,
      default: true,
      class: "resize-header",
      exportHeaders: [],
    },
  ];

  expandedRow: SortableTableHeader = {
    text: "VCustomer.remarks",
    value: "expandedRow",
    active: false,
    default: false,
    exportHeaders: ["remarks"],
  };

  filters = {
    name: "",
    eMail: "",
    telephoneNumber: "",
    identificationNumber: "",
    countryOfResidenceName: null,
    customerTypeId: null as any,
  };

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  get translatedActiveHeaders() {
    return this.headers
      .filter((x) => x.active)
      .map((x) => ({ ...x, text: this.$t(x.text) }));
  }

  @Ref("editDialog") editDialog?: {
    validate: () => boolean;
  };

  saveRemark(item: VCustomer) {
    const dialogValid = this.editDialog?.validate();
    if (!dialogValid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: "Customers.RemarksLenght",
        timeout: 5000,
        localize: true,
      } as Notification);

      this.load();
      return;
    }
    Vue.axios
      .post(`/Customers/UpdateCustomerRemark`, {
        id: item.id,
        remarks: item.remarks,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Customers.RemarkEditSuccess"),
          timeout: 5000,
        } as Notification);
      });
  }

  get rules() {
    return {
      maxLength: (value: string) =>
        !value ||
        value.length <= 500 ||
        this.$t("Validation.MaxLength", { count: 500 }),
    };
  }

  customerFormOpen = false;
  customerFormCustomerId: number | null = null;
  rowDoubleClick(e: MouseEvent, { item }: { item: VCustomer }) {
    this.openItemDetails(item);
  }
  openItemDetails(item: VCustomer) {
    this.customerFormCustomerId = item.id;
    this.customerFormOpen = true;
  }
  addItem() {
    this.customerFormCustomerId = null;
    this.customerFormOpen = true;
  }

  deleteItem(item: VCustomer) {
    this.$store.dispatch("showNotification", {
      id: item.id,
      color: "warning",
      message: this.$t("DeleteConfirmation") + ` '${item?.name}'`,
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteItemConfirm(item);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
  deleteItemConfirm({ id }: { id: number }) {
    Vue.axios
      .delete(`/customers/${id}`)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Customer.DeleteSuccess"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.$emit("refresh");
      });
  }

  openReservationsTab(item: VCustomer) {
    this.$router.push({
      name: "Customers.Reservations",
      query: {
        customerRole: this.filters.customerTypeId,
        customerId: item.id.toString(),
      },
    });
  }

  openMessages(id: number) {
    this.$router.push({
      name: "Messages",
      query: {
        customerId: id.toString(),
      },
    });
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["orderByName"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  loading = true;
  list: ListModel<VCustomer> = {
    count: 0,
    result: [],
  };
  get expanded() {
    if (this.expandedRow.active) {
      return this.list.result.filter((x) => !!x.remarks);
    } else {
      return [];
    }
  }

  debouncedLoad = _.debounce(this.load, 500);

  async load(): Promise<ListModel<VCustomer>> {
    this.loading = true;
    return this.axios
      .get<ListModel<VCustomer>>("/customers", {
        params: this.queryParams,
      })
      .then((res) => {
        this.list = res.data;
        return this.list;
      })
      .finally(() => (this.loading = false));
  }

  refresh() {
    this.debouncedLoad();
  }

  refreshAll() {
    this.$emit("refresh");
  }

  exportToExcel() {
    this.loading = true;

    return this.axios
      .get("customers/export/excel", {
        params: {
          ...this.queryParams,
          $skip: 0,
          $top: null,
          headers: this.headers
            .concat(this.expandedRow)
            .filter((h) => h.active)
            .flatMap((h) => h.exportHeaders)
            .join(","),
        },
        responseType: "blob",
      })
      .then((res) => {
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;
        saveFile(res.data, groups?.filename ?? "Customers.xlsx");
      })
      .finally(() => {
        this.loading = false;
      });
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy[0] == 'name' ? ["orderByName"] : this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filters,
    };
  }

  isLegalEntity(value: number) {
    return value === 1;
  }

  @Getter("codebooks/identificationDocumentTypes")
  identificationDocumentTypes?: IdentificationDocumentType[];
  @Action("codebooks/refreshIdentificationDocumentTypes")
  refreshIdentificationDocumentTypes?: () => Promise<void>;

  identificationDocumentTypeStyle(identificationDocumentTypeId: number) {
    if (this.identificationDocumentTypes) {
      return (
        this.identificationDocumentTypes.find(
          (x) => x.id == identificationDocumentTypeId
        ) ?? {}
      );
    }

    return {};
  }
}
